export const STANDARD_EDITOR = {
  ASSOCIATED_DOCUMENTS: 'Associated Documents',
  ASSOCIATED_EVIDENCES: 'Associated Evidences',
  NO_DOCUMENTS: 'No documents',
  NO_EVIDENCES: 'No evidences',
  NO_CODE: 'No code',
  NO_DESCRIPTION: 'No description',
  NO_IMPLEMENTATION_GUIDE: 'No implementation guide',
  NO_STANDARDS: 'No standards',
  TYPE: 'Type',
  CONTROL_DETAILS: 'Control Details',
  DOCUMENT_DETAILS: 'Document Details',
  EVIDENCE_DETAILS: 'Evidence Details',
  SELECT_DOCUMENT: 'Select a document...',
  SELECT_EVIDENCE: 'Select an evidence...',
  DELETE_CONTROL_TITLE: 'Delete Control',
  DELETE_CONTROL_QUESTION: 'Are you sure you want to delete',
  DELETE_CONTROL_IMPACT: (count: number) =>
    `This will remove the control from ${count} organization${count === 1 ? '' : 's'}.`,
  DELETE_CONTROL_CONFIRMATION: 'This action cannot be undone.',
  DELETE_DOCUMENT_TITLE: 'Delete Document',
  DELETE_DOCUMENT_QUESTION: 'Are you sure you want to delete',
  DELETE_DOCUMENT_CONFIRMATION: 'This action cannot be undone.',
  DELETE_DOCUMENT_IMPACT: (count: number) =>
    `This will remove the document from ${count} organization${count === 1 ? '' : 's'}.`,
  DELETE_DOCUMENT_WARNING_TITLE: 'Delete Document — Confirmation Required',
  DELETE_DOCUMENT_WARNING_INTRO: 'This document has user-modified data in adopting organizations:',
  DELETE_DOCUMENT_WARNING_SIGNATURES: (count: number) =>
    `${count} user${count === 1 ? ' has' : 's have'} signed this policy. Deleting will erase their signature${count === 1 ? '' : 's'}.`,
  DELETE_DOCUMENT_WARNING_FILES: (count: number) => `${count} custom file${count === 1 ? '' : 's'} will be deleted.`,
  DELETE_DOCUMENT_WARNING_LINKS: (count: number) => `${count} custom link${count === 1 ? '' : 's'} will be removed.`,
  DELETE_DOCUMENT_WARNING_ORGS_WITH_WORK: (count: number) =>
    `${count} organization${count === 1 ? ' has' : 's have'} progress on this document.`,
  DELETE_DOCUMENT_WARNING_STANDARDS: 'Also linked through the following standards:',
  DELETE_DOCUMENT_WARNING_CONFIRM: 'I understand and want to proceed',
  DELETE_EVIDENCE_TITLE: 'Delete Evidence',
  DELETE_EVIDENCE_QUESTION: 'Are you sure you want to delete',
  DELETE_EVIDENCE_CONFIRMATION: 'This action cannot be undone.',
  DELETE_EVIDENCE_IMPACT: (count: number) =>
    `This will remove the evidence from ${count} organization${count === 1 ? '' : 's'}.`,
  DELETE_EVIDENCE_WARNING_TITLE: 'Delete Evidence — Confirmation Required',
  DELETE_EVIDENCE_WARNING_INTRO: 'This evidence has user-modified data in adopting organizations:',
  DELETE_EVIDENCE_WARNING_FILES: (count: number) => `${count} uploaded file${count === 1 ? '' : 's'} will be deleted.`,
  DELETE_EVIDENCE_WARNING_LINKS: (count: number) => `${count} attached link${count === 1 ? '' : 's'} will be removed.`,
  DELETE_EVIDENCE_WARNING_ORGS_WITH_WORK: (count: number) =>
    `${count} organization${count === 1 ? ' has' : 's have'} progress on this evidence.`,
  DELETE_EVIDENCE_WARNING_STANDARDS: 'Also linked through the following standards:',
  DELETE_EVIDENCE_WARNING_CONFIRM: 'I understand and want to proceed',
  VALIDATION_CONTROL_REQUIRED: 'Control data is required',
  VALIDATION_DOCUMENT_REQUIRED: 'Document data is required',
  VALIDATION_EVIDENCE_REQUIRED: 'Evidence data is required',
  VALIDATION_NAME_REQUIRED: 'Name',
  VALIDATION_DESCRIPTION_REQUIRED: 'Description',
  VALIDATION_IMPLEMENTATION_GUIDE_REQUIRED: 'Implementation Guide',
  VALIDATION_TITLE: 'Missing Required Fields',
  VALIDATION_MESSAGE: 'Please fill in the following required fields before creating:',
  VALIDATION_BASIC_FIELDS: 'Basic Fields:',
  VALIDATION_TRANSLATIONS: 'Missing translations:',
  NO_DOCUMENT_TYPE: 'No document type',
  DOCUMENT_TYPES: {
    POLICY: 'Policy',
    DOCUMENT: 'Document',
    REGISTER: 'Register',
    PROCESS: 'Process',
    PROCEDURE: 'Procedure',
  },
  DOCUMENT_TYPE_SELECTOR: {
    SEARCH_TYPES: 'Search document types...',
    NO_TYPE_FOUND: 'No document type found',
  },
  PLATFORM_LINK: 'Platform link',
  PLATFORM_URL: 'Platform URL',
  PLATFORM_URL_PLACEHOLDER: 'e.g. /compliance/evidences',
  CAPABILITY: 'Capability',
  CAPABILITY_PLACEHOLDER: 'Select capability (optional)',
  NO_CAPABILITY: 'None',
}
